import { render, staticRenderFns } from "./ItemOverview.vue?vue&type=template&id=7fa91d96&scoped=true&"
import script from "./ItemOverview.vue?vue&type=script&lang=js&"
export * from "./ItemOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa91d96",
  null
  
)

export default component.exports